import React from "react";
import { connect } from "react-redux";
import { showDialog } from "../actions/dialog";
import $ from "jquery";
import _ from "lodash";
import { requireNotNull } from "../util/utils";
import Logger from "../util/Logger";
import { eventApi } from "../api/EventApi";
import { collectionApi } from "../api/CollectionApi";
import { ideaApi } from "../api/IdeaApi";
import { adoptExisting, clean, RealtimeUi } from "./RealtimeUi";
import { Realtime } from "./Realtime";
import "./PresentationPage.css";
import LoadingAndPulse from "../components/shared/LoadingAndPulse";
import { Animations } from "./animations/animation";
import Collection from "../models/Collection";
import Event from "../models/Event";
import Ideas from "../models/Ideas";
import { EventQuestionType } from "../models/EventQuestionType";
import FlipMove from "react-flip-move";
import POPinLogo from "../images/popin-logo-horizontal.svg";
import Response from "../models/Response";
import { GLOBAL_PATH_PREFIX } from "../constants";
import { commentApi } from "../api/CommentApi";
import { ChartContainer } from "../components/charts/ChartContainer";
import { NavigationUtils } from "../util/NavigationUtils";
import { LikeButton } from "./LikeButton";
import { LikeEvent } from "./animations/LikeEvent";
import { DislikeButton } from "./DislikeButton";
import { DislikeEvent } from "./animations/DislikeEvent";
import { CommentButton } from "./CommentButton";
import { CommentEvent } from "./animations/CommentEvent";
import { RatingButton } from "./RatingButton";
// TODO (Josh): Remove Component Files
// import { ActivityIcon } from './ActivityIcon';
import EventStats from "../models/EventStats";
import Media from "../models/Media";
import DateTime from "../models/DateTime";
import {
  COUNTDOWN_DURATION_IN_MILLIS,
  CountdownContainer
} from "./countdown/CountdownContainer";
import { PresentationPageAnalytics } from "../analytics/PresentationPageAnalytics";
import store from "../store/configureStore";
import { fetchUserSuccess } from "../actions/user";
import { fetchEventDetailsSuccess } from "../actions/event";
import { authApi } from "../api/AuthApi";
import { new400Error } from "../api/ApiError";
import { handleError } from "../util/Errors";
import { PromiseBatcher } from "promise-batching-queue";
import User from "../models/User";
import { BrowserChecker } from "../BrowserChecker";
import { TrackingAnalytics } from "../analytics/TrackingAnalytics";
import { ScreenRecorder } from "../util/ScreenRecorder";
import { ArchiveButton } from "./ArchiveButton";
import Comments from "../models/Comments";
import ArchivedTracker from "./ArchivedTracker";
import TextTruncate from "react-text-truncate";
// import TruncateMarkup from 'react-truncate-markup';

const FULLSCREEN_EVENT_STRING = `
  exitFullScreen
  enterFullScreen
  fullscreenchange
  fullscreenChange
  mozfullscreenchange
  mozFullscreenChange
  webkitfullscreenchange
  webkitFullscreenChange
  msfullscreenchange
  MSFullscreenChange
  `;

const isFullscreen = () => {
  // noinspection JSUnresolvedVariable
  const fullscreenElement =
    document.fullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullScreen;

  Logger.info("isFullscreen: ", fullscreenElement);
  return !!fullscreenElement;
};

/**
 * Toggles fullscreen mode
 *
 * This function can only be called within a click handler
 */
const toggleFullscreen = () => {
  let elem = document.getElementById("page-presentation");

  // Figure out the correct fullscreen functions
  // noinspection JSUnresolvedVariable
  const exitFullscreen =
    document.exitFullscreen ||
    document.mozExitFullscreen ||
    document.msExitFullscreen ||
    document.webkitExitFullscreen ||
    document.webkitCancelFullScreen ||
    document.mozCancelFullScreen ||
    document.cancelFullScreen;

  // noinspection JSUnresolvedVariable
  const requestFullscreen =
    elem.requestFullscreen ||
    elem.mozRequestFullScreen ||
    elem.msRequestFullscreen ||
    elem.webkitRequestFullscreen;

  Logger.info("exitFullscreen: ", exitFullscreen);
  Logger.info("requestFullscreen: ", requestFullscreen);

  if (!isFullscreen()) {
    // On Firefox this is a promise, but on all the other browsers it is not
    if (requestFullscreen) {
      requestFullscreen.call(elem);
    }
  } else {
    if (exitFullscreen) {
      exitFullscreen.call(document);
    }
  }
};

const Sorts = {
  MOST_POPULAR: "Most Popular",
  NEWEST: "Newest",
  MOST_COMMENTED: "Most Commented"
};

class PresentationPage extends React.Component {
  state = {
    isFullscreen: isFullscreen(),
    fullScreenStartTime: null,
    showFocused: false,
    focused: null,
    newestContent: null,
    activeSort: Sorts.MOST_POPULAR,
    activeSortStartTime: DateTime.now(),
    user: null,
    ideas: [],
    event: null,
    collection: null,
    countdownShown: false
  };

  realtimeQueue = PromiseBatcher.newSerialQueue();
  countdownTimer = null;

  unbinderCreate = null;
  unbinderEdited = null;
  unbinderStubbed = null;
  unbinderDeleted = null;
  unbinderStatsUpdated = null;
  unbinderCollection = null;
  unbinderUser = null;

  componentDidMount() {
    TrackingAnalytics.mixpanelTrackPageViewed();

    // Mobile blocked from Org dash
    if (BrowserChecker.isMobile()) {
      NavigationUtils.backToPopin();
      return;
    }

    // When we enter scope, turn off page scrolling. The content list will scroll itself
    this.enableContainerPadding(false);
    this.enablePageScrolling(false);
    this.listenForFullscreenChanges();

    this.bindKeysToCycling();

    const { event, match } = this.props;

    const eventSlug = event ? Event.getSlug(event) : match.params.event;
    if (!!eventSlug) {
      this.initPage(
        eventSlug,
        (event, collection) => {
          // At this point we have an event and possibly a collection.
          // But we aren't going to set anything until we have returned from the ideas/list call
          // so that we can display the whole page at once.
          this.loadEverything(
            event,
            ({ ideas, stats }) => {
              Logger.info("Page load everything");
              PresentationPageAnalytics.presentationViewLoaded();
              // Once we have loaded the ideas, we can show the page content now that everything is loaded
              this.setState(
                {
                  ideas: this.sortIdeas(ideas),
                  stats,
                  event,
                  collection
                },
                () => {
                  Logger.info("Begin realtime after everything");
                  this.openRealtimeConnection();
                  this.openCollectionRealtime();
                  this.openUserRealtime();
                }
              );
            },
            this.dataLoadErrorCallback
          );
        },
        this.pageLoadErrorCallback,
        this.dataLoadErrorCallback
      );
    }
  }

  killAllRealtime = () => {
    this.unbinderCollection = this.unbind(this.unbinderCollection);
    this.unbinderUser = this.unbind(this.unbinderUser);
    this.unbindAll();
    Realtime.unsubscribeRealtime(this.state.event);
  };

  componentWillUnmount() {
    this.killAllRealtime();
    this.stopListenForFullscreenChanges();

    // When we leave scope, turn on page scrolling again
    this.enableContainerPadding(true);
    this.enablePageScrolling(true);
  }

  componentDidUpdate() {
    this.ellipsizeEventName();
    this.checkCountdownTimer();
  }

  // If the event is ending in less than 5 minutes, set a timer and wait for the event, otherwise show timer
  checkCountdownTimer = () => {
    const { event } = this.state;
    if (!event) {
      Logger.info("Cannot set countdown timer until we have an event");
      return;
    }

    if (!!this.countdownTimer) {
      clearTimeout(this.countdownTimer);
      this.countdownTimer = null;
    }

    // Get times
    const endTime = Event.getEndTime(event);
    const now = DateTime.now();

    // Compare times
    const timeUntilEventEnds = DateTime.duration(endTime.diff(now));
    const timeUntilEventEndsMillis = timeUntilEventEnds.valueOf();

    // Does the event end in 5 minutes
    const eventEndsSoon =
      timeUntilEventEndsMillis < COUNTDOWN_DURATION_IN_MILLIS;

    // If the event ends soon
    if (eventEndsSoon) {
      // Show the countdown if not shown yet.
      if (!this.state.countdownShown) {
        Logger.info("Event is ending soon, show timer");
        this.setState({ countdownShown: true }, () => {
          this.notifyCountdown();
        });
      }
    } else {
      const startTimer = () => {
        // While Javascript can handle large numbers just fine, setTimeout requires a 32 bit integer for the number.
        // Thus, we must check if our timeUntilEventEndsMillis is greater than TIMEOUT_MAX and if so,
        // set the timer for TIMEOUT_MAX - 1;
        const TIMEOUT_MAX = 0x7fffffff;
        let safeTime =
          Math.min(TIMEOUT_MAX, timeUntilEventEndsMillis) -
          COUNTDOWN_DURATION_IN_MILLIS;
        if (!this.countdownTimer) {
          Logger.info("Start a countdown timer to trigger in", safeTime);
          this.countdownTimer = setTimeout(() => {
            // Recur
            this.checkCountdownTimer();
          }, safeTime);
        }
      };

      // If the countdown is shown
      if (this.state.countdownShown) {
        // Hide it and start timer
        Logger.info("Timer is shown but countdown is not ready yet, hide it.");
        this.setState({ countdownShown: false }, () => {
          startTimer();
        });
      } else {
        // Otherwise just start timer
        startTimer();
      }
    }
  };

  notifyCountdown = () => {
    const { event } = this.state;
    if (Event.isUserCreated(event) && !Event.isClosed(event)) {
      const { showDialog } = this.props;
      showDialog({
        body: (
          <div>
            You're running out of time, Would you like to extend this POPin by a
            day?
          </div>
        ),
        ok: "Yes",
        onOk: () => {
          PresentationPageAnalytics.extendedTime("1 day");
          eventApi.extendPopinTime(event).then(extended => {
            Logger.info("Event extended by a day");
            this.onRealtimeEventUpdate(extended, false);
          });
        },
        cancel: "Not Now",
        onCancel: () => {
          PresentationPageAnalytics.didNotExtend();
        }
      });
    }
  };

  openUserRealtime = () => {
    const onLogout = reason => {
      Logger.info("User has been logged out: ", reason);
      this.killAllRealtime();

      const { showDialog } = this.props;
      showDialog({
        closeOnClickOutside: false,
        closeOnEscape: false,
        title: "Session Expired",
        body: <div>You have been logged out.</div>,
        ok: "Ok",
        onOk: () => {
          NavigationUtils.backToPopin();
        }
      });
    };

    this.unbinderUser = this.unbind(this.unbinderUser);
    if (!!this.state.user && !!this.state.user.id) {
      this.unbinderUser = Realtime.subscribeToRealtime(
        this.state.user,
        "status",
        () => {
          // Just hit /account/settings
          // If we are actually logged out, the session will die, otherwise life continues
          authApi
            .settings()
            .then(user => {
              // Not actually logged out, continue
              this.setState({ user });
            })
            .catch(onLogout);
        },
        onLogout
      );
    }
  };

  openCollectionRealtime = () => {
    this.unbinderCollection = this.unbind(this.unbinderCollection);
    if (!!this.state.collection && !!this.state.collection.id) {
      this.unbinderCollection = Realtime.subscribeToRealtime(
        this.state.collection,
        "edited",
        () => {
          setTimeout(() => {
            this.joinCollection(
              this.state.collection.id,
              collection => {
                Logger.info(
                  "Set collection after realtime update: ",
                  collection
                );
                this.setState({ collection });
              },
              error => {
                Logger.error(
                  "Failed to refresh Collection after realtime event"
                );
                this.dataLoadErrorCallback(error);
              }
            );
          }, 2000);
        },
        error => {
          Logger.error("Failed to open realtime to Collection");
          this.realtimeErrorCallback(error);
        }
      );
    }
  };

  getLineCount = div => {
    const element = div[0];
    if (!!element) {
      const viewportOffset = element.getBoundingClientRect();
      const divHeight = parseInt(
        viewportOffset.bottom - viewportOffset.top,
        10
      );

      let lineHeight = getComputedStyle(element).getPropertyValue(
        "line-height"
      );
      if (String("normal|initial|inherit").indexOf(lineHeight) > -1) {
        //very specific case
        lineHeight =
          parseInt(
            getComputedStyle(element).getPropertyValue("font-size"),
            10
          ) + 2;
      }
      lineHeight = parseInt(lineHeight, 10);

      return divHeight / lineHeight;
    } else {
      return 0;
    }
  };

  ellipsizeEventName = () => {
    const eventNameDiv = $(".event-name");
    if (!!eventNameDiv) {
      const lineCount = this.getLineCount(eventNameDiv);
      const windowWidth = $(window).width();
      const css = { "line-height": "1.2" };

      const RES_1440P = 2560;
      const RES_3K = 3000;
      const RES_3K_ISH = 3400;
      const RES_4K = 3840;

      if (lineCount > 4) {
        // Very large amount of lines
        if (windowWidth >= RES_4K) {
          css["font-size"] = "3.5rem";
        } else if (windowWidth >= RES_3K_ISH) {
          css["font-size"] = "3rem";
        } else if (windowWidth >= RES_3K) {
          css["font-size"] = "2.5rem";
        } else if (windowWidth >= RES_1440P) {
          css["font-size"] = "2rem";
        } else {
          css["font-size"] = "1.5rem";
        }
      } else if (lineCount > 2) {
        // Mid length lines
        if (windowWidth >= RES_4K) {
          css["font-size"] = "4.2rem";
        } else if (windowWidth >= RES_3K_ISH) {
          css["font-size"] = "3.65rem";
        } else if (windowWidth >= RES_3K) {
          css["font-size"] = "3.1rem";
        } else if (windowWidth >= RES_1440P) {
          css["font-size"] = "2.55rem";
        } else {
          css["font-size"] = "2rem";
        }
      } else {
        // Normal length lines
        if (windowWidth >= RES_4K) {
          css["font-size"] = "5rem";
        } else if (windowWidth >= RES_3K_ISH) {
          css["font-size"] = "4.3rem";
        } else if (windowWidth >= RES_3K) {
          css["font-size"] = "3.7rem";
        } else if (windowWidth >= RES_1440P) {
          css["font-size"] = "3.1rem";
        } else {
          css["font-size"] = "2.5rem";
        }
      }
      eventNameDiv.css(css);
    }
  };

  onFullscreenChanged = () => {
    const inFullScreenMode = isFullscreen();
    let fullscreenDuration = null;
    if (!!inFullScreenMode) {
      this.setState({ fullScreenStartTime: DateTime.now() });
    } else {
      fullscreenDuration = DateTime.diffInMinutes(
        this.state.fullScreenStartTime,
        DateTime.now()
      );
      this.setState({ fullScreenStartTime: null }); // reset
    }
    Logger.info("Fullscreen state changed: ", inFullScreenMode);
    PresentationPageAnalytics.fullScreenModeChanged(
      inFullScreenMode,
      fullscreenDuration
    );
    this.setState({ isFullscreen: inFullScreenMode });
  };

  listenForFullscreenChanges = () => {
    $(document).on(FULLSCREEN_EVENT_STRING, this.onFullscreenChanged);
  };

  stopListenForFullscreenChanges = () => {
    $(document).off(FULLSCREEN_EVENT_STRING, this.onFullscreenChanged);
  };

  updateFocusedContent = (deleted = null) => {
    if (this.state.focused) {
      const foundId = deleted && ArchivedTracker.find(deleted.id);
      if (!!deleted && this.state.focused.id === deleted.id) {
        Logger.info(
          "Focused card has been deleted, kick user out after message"
        );
        if (!foundId) {
          const { showDialog } = this.props;
          showDialog({
            closeOnClickOutside: false,
            closeOnEscape: false,
            title: "Sorry",
            body: <div>This content was removed by the original poster.</div>,
            ok: "Ok",
            onOk: () => {
              this.setState({ focused: null }, () => {
                // And remove newest content if it was the thing
                this.onRealtimeRemoveNewest(deleted);
              });
            }
          });
        } else {
          this.setState({ focused: null }, () => {
            // And remove newest content if it was the thing
            this.onRealtimeRemoveNewest(deleted);
          });
        }
      } else {
        for (let idea of this.state.ideas) {
          if (idea.id === this.state.focused.id) {
            this.setState({ focused: idea });
            break;
          }
        }
      }
    }
  };

  updateCommentsForIdea = idea => {
    this.setState(
      {
        ideas: RealtimeUi.onContentEdited(
          this.state.event,
          idea,
          this.state.ideas
        )
      },
      () => this.updateFocusedContent(null)
    );
  };

  animateFadeInFadeOut = className => {
    Animations.animate(
      className,
      {
        opacity: 1,
        delay: 100
      },
      () => {
        Animations.animate(className, {
          opacity: 0,
          delay: 600
        });
      }
    );
  };

  onMouseMoveEvent = () => {
    this.animateFadeInFadeOut(".fullscreen-toggle");
    this.animateFadeInFadeOut(".switch-next");
    this.animateFadeInFadeOut(".switch-previous");
  };

  render() {
    const {
      user,
      collection,
      newestContent,
      ideas,
      event,
      stats,
      focused,
      activeSort,
      isFullscreen,
      countdownShown
    } = this.state;
    const currentEventId = !!event ? Event.getId(event) : "";
    const eventList = !!collection ? Collection.getEvents(collection) : [];

    const canSwitchToNext = this.canSwitchToNextEvent(
      currentEventId,
      eventList
    );
    const canSwitchToPrevious = this.canSwitchToPreviousEvent(
      currentEventId,
      eventList
    );

    return (
      <div id="page-presentation" className="presentation-page row no-gutters">
        {!!event ? (
          <div
            onMouseMove={this.onMouseMoveEvent}
            id="presentation-loaded-section"
            className="presentation-loaded-section h-100 w-100 row no-gutters"
          >
            {/* Floating Fullscreen button */}
            {!isFullscreen && (
              <div className="fullscreen-toggle">
                <div className="row no-gutters">
                  <div
                    className="p-2 my-2 mx-auto fullscreen-message"
                    onClick={toggleFullscreen}
                  >
                    <div className="row no-gutters my-auto">
                      <i className="material-icons mr-2 my-auto">fullscreen</i>
                      <div className="h-100 text-center my-auto">
                        <div className="my-auto fullscreen-text">
                          Enter full screen
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Floating Previous Event button */}
            {/* { canSwitchToPrevious && (
                <div className="switch-previous d-flex h-100">
                  <div className="h-100 d-flex flex-column">
                    <div
                      className="switch-message mx-3 my-auto"
                      onClick={ () => this.switchToPreviousEvent(currentEventId, eventList, false, true) }>
                      <i className="material-icons">keyboard_arrow_left</i>
                    </div>
                  </div>
                </div>
              ) } */}

            {/* Floating Next Event button */}
            {/* { canSwitchToNext && (
                <div className="switch-next d-flex h-100">
                  <div className="h-100 d-flex flex-column">
                    <div
                      className="switch-message mx-3 my-auto"
                      onClick={ () => this.switchToNextEvent(currentEventId, eventList, false, true) }>
                      <i className="material-icons">keyboard_arrow_right</i>
                    </div>
                  </div>
                </div>
              ) } */}

            <div
              id="presentation-code-section"
              className="presentation-code-section row col-lg-3 no-gutters"
            >
              <CodeSection
                event={event}
                collection={collection}
                stats={stats}
                countdownShown={countdownShown}
                canSwitchToPreviousEvent={canSwitchToPrevious}
                canSwitchToNextEvent={canSwitchToNext}
                switchToNextEvent={() =>
                  this.switchToNextEvent(
                    currentEventId,
                    eventList,
                    false,
                    false
                  )
                }
                switchToPreviousEvent={() =>
                  this.switchToPreviousEvent(
                    currentEventId,
                    eventList,
                    false,
                    false
                  )
                }
              />
            </div>

            <div
              id="presentation-list-section"
              className={`presentation-list-section row no-gutters col-lg-9 ${
                EventQuestionType.isOpenEndedType(Event.getQuestionType(event))
                  ? ""
                  : "not-default"
              }`}
            >
              <ListSection
                user={user}
                event={event}
                ideas={ideas}
                stats={stats}
                activeSort={activeSort}
                focused={focused}
                onSortPicked={this.pickSort}
                onCommentsFetched={this.updateCommentsForIdea}
                onFocused={this.onFocusedUpdated}
                showFocused={this.state.showFocused}
                updateShowFocused={callback =>
                  this.setState(
                    { showFocused: !this.state.showFocused },
                    callback
                  )
                }
                newestContent={newestContent}
              />
            </div>
          </div>
        ) : (
          <div className="col h-100 w-100 d-flex">
            <div className="m-auto col">
              <LoadingAndPulse size={20} color="#3D9AE2" whatIsLoading="" />
            </div>
          </div>
        )}
      </div>
    );
  }

  onFocusedUpdated = focusedCard => {
    Logger.info("Set focusedCard: ", focusedCard);
    // the focusedCard param will either be the idea card to be expanded,
    // the string 'collapse-button-clicked' (if the user closed the card by clicking the collapse button)
    // or null if the user just clicked the card again to close it
    if (!focusedCard) {
      PresentationPageAnalytics.cardCollapsed(false); // card closed by clicking on the card again
    } else if (focusedCard === "collapse-button-clicked") {
      PresentationPageAnalytics.cardCollapsed(true); // card closed via collapse button
      focusedCard = null; // null this out so that we don't set the focused card on state to be a string
    } else if (focusedCard.id) {
      PresentationPageAnalytics.cardFocused();
    }
    this.setState({ focused: focusedCard });
  };

  pickSort = ($event, sort) => {
    $event.preventDefault();
    Logger.info("Change active sort", sort);
    const durationOfLastSort = DateTime.diffInMinutes(
      this.state.activeSortStartTime,
      DateTime.now()
    );
    PresentationPageAnalytics.sortChanged(
      sort,
      this.state.activeSort,
      durationOfLastSort
    );
    ScreenRecorder.trackCustomAction(`SORT_SELECTED_${this.state.activeSort}`);
    this.setState(
      {
        activeSort: sort,
        activeSortStartTime: DateTime.now()
      },
      () => {
        this.setState({
          ideas: this.sortIdeas(this.state.ideas)
        });
      }
    );
  };

  /**
   * Unbind an Unbinder and then return a null to blank out the unbinder. Yeah it could be better.
   *
   * @param unbinder
   * @return {null}
   */
  unbind = unbinder => {
    if (!!unbinder) {
      unbinder.unbind();
    }

    return null;
  };

  /**
   * Unbind everything
   */
  unbindAll = () => {
    this.unbinderCreate = this.unbind(this.unbinderCreate);
    this.unbinderEdited = this.unbind(this.unbinderEdited);
    this.unbinderDeleted = this.unbind(this.unbinderDeleted);
    this.unbinderStubbed = this.unbind(this.unbinderStubbed);
    this.unbinderStatsUpdated = this.unbind(this.unbinderStatsUpdated);
  };

  /**
   * Toggle on or off the page scrolling
   *
   * @param enable
   */
  enablePageScrolling = enable => {
    const body = $("html");
    body.css({
      overflow: enable ? "" : "hidden"
    });

    const div = $("#intercom_chat_icon");
    div.css({ display: enable ? "block" : "none" });
  };

  /**
   * Toggle on or off the container padding (hide the navbar spacing)
   *
   * @param enable
   */
  enableContainerPadding = enable => {
    const div = $(".container-padding");
    div.css({
      "margin-top": enable ? "4rem" : "0"
    });
  };

  /**
   * Call /events/join given an event slug
   *
   * @param eventSlug
   * @param onSuccess
   * @param onError
   */
  loadUser = (eventSlug, onSuccess, onError) => {
    // Developer
    requireNotNull(eventSlug);
    requireNotNull(onSuccess);
    requireNotNull(onError);

    authApi
      .authenticate(false)
      .then(user => {
        Logger.info("User load success ", user);
        onSuccess(user);
      })
      .catch(() => {
        // Failed to auth user, try to verify
        authApi
          .verify(eventSlug)
          .then(user => {
            Logger.info("User load success ", user);
            onSuccess(user);
          })
          .catch(error => {
            Logger.error("User load error ", error);
            // If the error is that the user is restricted (403 or 405 as guest), we show custom error dialog and message
            if (error.code === 403 || error.code === 405) {
              onError(error);
            } else {
              // Otherwise, we handle as usual
              if (
                !handleError(error, null, () => {
                  // User is forbidden or event is not found and a default Error dialog is shown.
                  // On Ok click, we take them back to dashboard
                  if (
                    error.code === 403 ||
                    error.code === 404 ||
                    error.code === 405
                  ) {
                    NavigationUtils.backToPopin();
                  }
                })
              ) {
                onError(error);
              }
            }
          });
      });
  };

  bindKeysToCycling = () => {
    this.bindKeycode(37, true); // left arrow previous
    this.bindKeycode(39, false); // right arrow next
  };

  switchAndReloadEvent = event => {
    this.setState(
      {
        event: null,
        stats: null,
        focused: null,
        newestContent: null,
        activeSort: Sorts.MOST_POPULAR,
        ideas: []
      },
      () => {
        // Close realtime for old event
        this.unbindAll();

        // Rewrite the URL so that page refreshing goes to the correct Event, and for visual consistency
        const replacePath = `${GLOBAL_PATH_PREFIX}/q/${Event.getSlug(
          event
        )}/present`;
        window.history.replaceState(null, null, replacePath);

        Logger.info("Load new event everything");
        this.loadEverything(
          event,
          ({ ideas, stats }) => {
            // Once we have loaded the ideas, we can show the page content now that everything is loaded
            this.setState(
              {
                ideas: this.sortIdeas(ideas),
                stats,
                event
              },
              () => {
                Logger.info("Begin realtime after everything");
                this.openRealtimeConnection();
              }
            );
          },
          this.dataLoadErrorCallback
        );
      }
    );
  };

  canSwitchToPreviousEvent = (currentEventId, eventList) => {
    if (!eventList) {
      return false;
    }

    if (eventList.length <= 0) {
      return false;
    }

    return currentEventId !== Event.getId(eventList[0]);
  };

  switchToPreviousEvent = (
    currentEventId,
    eventList,
    isKeyboardClick,
    isHoverBtn
  ) => {
    // If this is not the first event, we can go previous
    if (this.canSwitchToPreviousEvent(currentEventId, eventList)) {
      // Find the index of our current event
      let index = -1;
      for (let i = 0; i < eventList.length; ++i) {
        const checkMe = eventList[i];
        if (Event.getId(checkMe) === currentEventId) {
          index = i;
          break;
        }
      }

      // If we have an index, set the event to 1 before us
      if (index >= 0) {
        const questionNum = index;
        PresentationPageAnalytics.switchToPrevious(
          questionNum,
          eventList.length,
          isKeyboardClick,
          isHoverBtn
        );
        Logger.info("Switch to previous event");
        this.switchAndReloadEvent(eventList[index - 1]);
      }
    }
  };

  canSwitchToNextEvent = (currentEventId, eventList) => {
    if (!eventList) {
      return false;
    }

    if (eventList.length <= 0) {
      return false;
    }

    return currentEventId !== Event.getId(eventList[eventList.length - 1]);
  };

  switchToNextEvent = (
    currentEventId,
    eventList,
    isKeyboardClick,
    isHoverBtn
  ) => {
    // If this is not the last event, we can go next
    if (this.canSwitchToNextEvent(currentEventId, eventList)) {
      // Find the index of our current event
      let index = -1;
      for (let i = 0; i < eventList.length; ++i) {
        const checkMe = eventList[i];
        if (Event.getId(checkMe) === currentEventId) {
          index = i;
          break;
        }
      }

      // If we have an index, set the event to 1 before us
      if (index >= 0) {
        const questionNum = index + 2;
        PresentationPageAnalytics.switchToNext(
          questionNum,
          eventList.length,
          isKeyboardClick,
          isHoverBtn
        );
        Logger.info("Switch to next event");
        this.switchAndReloadEvent(eventList[index + 1]);
      }
    }
  };

  bindKeycode = (code, goToPrevious) => {
    Logger.info(`Bind keycode ${code}`);

    $(document).keydown($key => {
      if ($key.keyCode === code) {
        Logger.info("Keycode matches: ", code);
        $key.preventDefault();

        if (
          !!this.state.event &&
          !!this.state.collection &&
          Collection.isConcurrentEnabled(this.state.collection)
        ) {
          const eventId = Event.getId(this.state.event);
          const eventList = Collection.getEvents(this.state.collection);
          if (goToPrevious) {
            this.switchToPreviousEvent(eventId, eventList, true, false);
          } else {
            this.switchToNextEvent(eventId, eventList, true, false);
          }
        }
      }
    });
  };

  /**
   * Call /events/join given an event slug
   *
   * @param slug
   * @param onSuccess
   * @param onError
   */
  joinEvent = (slug, onSuccess, onError) => {
    // Developer
    requireNotNull(slug);
    requireNotNull(onSuccess);
    requireNotNull(onError);

    eventApi
      .join(slug)
      .then(event => {
        Logger.info("Event join success ", event);
        onSuccess(event);
      })
      .catch(error => {
        Logger.error("Event join error ", error);
        // If its a 403 or 405, handle custom error
        if (error.code === 403 || error.code === 405) {
          onError(error);
        } else {
          if (!handleError(error, null)) {
            onError(error);
          }
        }
      });
  };

  /**
   * Call /collections/join given a collection id
   *
   * @param collectionId
   * @param onSuccess
   * @param onError
   */
  joinCollection = (collectionId, onSuccess, onError) => {
    // Developer
    requireNotNull(collectionId);
    requireNotNull(onSuccess);
    requireNotNull(onError);

    collectionApi
      .join(collectionId)
      .then(collection => {
        Logger.info("Collection join success ", collection);
        onSuccess(collection);
      })
      .catch(error => {
        Logger.error("Collection join error ", error);
        if (!handleError(error, null)) {
          onError(error);
        }
      });
  };

  /**
   * The single entry point for all things page loading
   *
   * @param eventSlug
   * @param onPageInitSuccess
   * @param onPageInitError
   * @param onDataLoadError
   */
  initPage = (
    eventSlug,
    onPageInitSuccess,
    onPageInitError,
    onDataLoadError
  ) => {
    requireNotNull(eventSlug);
    requireNotNull(onPageInitSuccess);
    requireNotNull(onPageInitError);

    this.loadUser(
      eventSlug,
      user => {
        // This will be caught and handled
        if (!User.isLiveEnabled(user)) {
          throw new400Error(
            "",
            "POPin LIVE is not enabled for your Organization."
          );
        }

        this.setState({ user }, () => {
          // Update redux for mixpanel
          store.dispatch(fetchUserSuccess(user));
          ScreenRecorder.record(false);
        });
        this.joinEvent(
          eventSlug,
          event => {
            store.dispatch(fetchEventDetailsSuccess(event));
            // If we have a collection, join it too
            if (!!_.get(event, "collection.id")) {
              this.joinCollection(
                Collection.getId(Event.getCollection(event)),
                collection => {
                  onPageInitSuccess(event, collection);
                },
                error => {
                  if (!handleError(error, null)) {
                    onDataLoadError(error);
                  }
                }
              );
            } else {
              onPageInitSuccess(event, null);
            }
          },
          error => {
            // Custom handle error 403 and 405
            if (error.code === 403 || error.code === 405) {
              onDataLoadError(error);
            } else {
              // Else standard error handling
              if (!handleError(error, null)) {
                onDataLoadError(error);
              }
            }
          }
        );
      },
      error => {
        // Custom handle error 403 and 405
        if (error.code === 403 || error.code === 405) {
          onPageInitError(error);
        } else {
          // Else standard error handling
          if (!handleError(error, null)) {
            onPageInitError(error);
          }
        }
      }
    );
  };

  /**
   * Load everything for the event
   *
   * @param event
   * @param onLoadSuccess (idea, stats)
   * @param onLoadError welp
   */
  loadEverything = (event, onLoadSuccess, onLoadError) => {
    // Stop realtime while we load ideas
    this.unbindAll();

    let loadedIdeas = null;
    let loadedStats = null;

    // Do this ugly thing so we can resolve these in parallel.
    new Promise((resolve, reject) => {
      this.loadIdeas(
        event,
        ideas => {
          loadedIdeas = ideas;
          if (!!loadedIdeas && !!loadedStats) {
            resolve({ ideas: loadedIdeas, stats: loadedStats });
          }
        },
        error => {
          Logger.error("loadEverything error: ideas");
          reject(error);
        }
      );

      this.loadStats(
        event,
        stats => {
          loadedStats = stats;
          if (!!loadedIdeas && !!loadedStats) {
            resolve({ ideas: loadedIdeas, stats: loadedStats });
          }
        },
        error => {
          Logger.error("loadEverything error: stats");
          reject(error);
        }
      );
    })
      .then(payload => {
        Logger.info("loadEverything done");
        PresentationPageAnalytics.previousPopinStartTimer();
        PresentationPageAnalytics.nextPopinStartTimer();
        onLoadSuccess(payload);
      })
      .catch(error => {
        Logger.error("loadEverything something is wrong");
        if (!handleError(error, null)) {
          onLoadError(error);
        }
      });
  };

  /**
   * Load ideas from the event
   *
   * @param event
   * @param onIdeasLoadSuccess
   * @param onIdeasLoadError
   */
  loadIdeas = (event, onIdeasLoadSuccess, onIdeasLoadError) => {
    ideaApi
      .getIdeas(Event.getId(event))
      .then(ideas => {
        Logger.info("Loaded ideas for event: ", Event.getId(event));
        onIdeasLoadSuccess(ideas);
      })
      .catch(error => {
        Logger.error("Error loading ideas for event", Event.getId(event));
        if (!handleError(error, null)) {
          onIdeasLoadError(error);
        }
      });
  };

  /**
   * Load ideas from the event
   *
   * @param event
   * @param onStatsLoadSuccess
   * @param onStatsLoadError
   */
  loadStats = (event, onStatsLoadSuccess, onStatsLoadError) => {
    eventApi
      .getMiniStats(Event.getId(event))
      .then(stats => {
        Logger.info("Loaded stats for event: ", Event.getId(event));
        onStatsLoadSuccess(stats);
      })
      .catch(error => {
        Logger.error("Error loading stats for event", Event.getId(event));
        if (!handleError(error, null)) {
          onStatsLoadError(error);
        }
      });
  };

  isEvent = data => {
    // noinspection JSUnresolvedVariable
    return data.share_link !== undefined && data.share_link !== null;
  };

  isIdea = data => {
    return data.content !== undefined && data.content !== null;
  };

  isComment = data => {
    // noinspection JSUnresolvedVariable
    return data.hero_replied !== undefined && data.hero_replied !== null;
  };

  isVote = data => {
    return data.vote !== undefined;
  };

  onRealtimeEventUpdate = (dirtyEvent, deleted) => {
    Logger.info("Realtime event update");
    if (this.state.event) {
      if (this.state.event.id === dirtyEvent.id) {
        const event = clean(dirtyEvent);
        adoptExisting(event, this.state.event);

        Logger.info("Realtime event matches");
        if (deleted) {
          Logger.info("Realtime event deleted");
          PresentationPageAnalytics.liveQuestionDelete();
          const { showDialog } = this.props;
          // TODO Strings
          showDialog({
            closeOnClickOutside: false,
            closeOnEscape: false,
            title: "Sorry",
            body: <div>This event has been deleted.</div>,
            ok: "Ok",
            onOk: () => {
              if (this.state.collection) {
                this.joinCollection(
                  Collection.getId(this.state.collection),
                  collection => {
                    if (collection) {
                      const e = Collection.getEvents(collection)[0];
                      this.switchAndReloadEvent(e, () => {
                        window.location.reload();
                      });
                    } else {
                      NavigationUtils.routeToLegacy("/q");
                    }
                  },
                  error => {
                    Logger.error(
                      "Error getting collection from realtime update",
                      error
                    );
                    NavigationUtils.routeToLegacy("/q");
                  }
                );
              } else {
                NavigationUtils.routeToLegacy("/q");
              }
            }
          });
        } else {
          Logger.info("Realtime event updated");
          PresentationPageAnalytics.liveQuestionEdit();
          this.loadEverything(
            event,
            ({ ideas, stats }) => {
              this.setState({ event, ideas, stats }, () => {
                this.openRealtimeConnection();
                this.ellipsizeEventName();

                // Hide the countdown timer so that the timer view refreshes
                this.setState({ countdownShown: false }, () => {
                  this.checkCountdownTimer();
                });
              });
            },
            error => {
              Logger.error("Error reloading everything: ", error);
              this.dataLoadErrorCallback(error);
            }
          );
        }
      }
    }
  };

  onRealtimeCreateOpenEndedIdea = idea => {
    PresentationPageAnalytics.liveIdeaCreated();
    this.onRealtimeUpdateNewest(idea);

    this.setState(
      {
        ideas: this.sortIdeas(
          RealtimeUi.onContentCreated(this.state.event, idea, this.state.ideas)
        )
      },
      () => {
        this.updateFocusedContent(null);
      }
    );
  };

  onRealtimeCreateOpenEndedComment = comment => {
    // noinspection JSUnresolvedVariable
    this.setState(
      {
        ideas: RealtimeUi.onNestedContentCreated(
          this.state.event,
          comment,
          this.state.ideas,
          comment.parent_idea_id
        )
      },
      () => this.updateFocusedContent(null)
    );
  };

  onRealtimeCreateVote = vote => {
    // noinspection JSUnresolvedVariable
    if (!!vote.vote) {
      PresentationPageAnalytics.liveUpvote(!!vote.idea_id);
    } else {
      PresentationPageAnalytics.liveDownvote(!!vote.idea_id);
    }
  };

  onRealtimeCreate = data => {
    if (this.isEvent(data)) {
      this.onRealtimeEventUpdate(data, false);
    } else {
      if (this.isIdea(data)) {
        if (
          EventQuestionType.isOpenEndedType(
            Event.getQuestionType(this.state.event)
          )
        ) {
          this.onRealtimeCreateOpenEndedIdea(data);
        } else {
          PresentationPageAnalytics.liveResponseToScaleBinaryMultiple();
        }
      } else if (this.isComment(data)) {
        PresentationPageAnalytics.liveCommentCreated();
        if (
          EventQuestionType.isOpenEndedType(
            Event.getQuestionType(this.state.event)
          )
        ) {
          this.onRealtimeCreateOpenEndedComment(data);
        }
      } else if (this.isVote(data)) {
        this.onRealtimeCreateVote(data);
      }
    }
  };

  onRealtimeEditOpenEndedIdea = idea => {
    this.onRealtimeEditNewest(idea);

    // So, on edit, I'm not going to sort the list because it's expensive
    // and it is highly improbable that a new response will join the list
    // and instantly be the most popular.
    this.setState(
      {
        ideas: RealtimeUi.onContentEdited(
          this.state.event,
          idea,
          this.state.ideas
        )
      },
      () => this.updateFocusedContent(null)
    );
  };

  onRealtimeEditOpenEndedComment = comment => {
    // noinspection JSUnresolvedVariable
    this.setState(
      {
        ideas: RealtimeUi.onNestedContentEdited(
          this.state.event,
          comment,
          this.state.ideas,
          comment.parent_idea_id
        )
      },
      () => this.updateFocusedContent(null)
    );
  };

  onRealtimeEdit = data => {
    if (this.isEvent(data)) {
      this.onRealtimeEventUpdate(data, false);
    } else {
      if (this.isIdea(data)) {
        if (
          EventQuestionType.isOpenEndedType(
            Event.getQuestionType(this.state.event)
          )
        ) {
          this.onRealtimeEditOpenEndedIdea(data);
        }
      } else if (this.isComment(data)) {
        if (
          EventQuestionType.isOpenEndedType(
            Event.getQuestionType(this.state.event)
          )
        ) {
          this.onRealtimeEditOpenEndedComment(data);
        }
      }
    }
  };

  onRealtimeUpdateNewest = idea => {
    // We hide any photos in realtime because we are afraid of coc
    // so if this has a photo, it is not allowed to be the newest content.
    if (!Response.getPhotoAttachment(idea)) {
      this.setState({ newestContent: idea });
    }
  };

  onRealtimeDeleteOpenEndedIdea = idea => {
    this.onRealtimeRemoveNewest(idea);

    // Sort on delete in case the most popular has been deleted
    this.setState(
      {
        ideas: this.sortIdeas(
          RealtimeUi.onContentDeleted(this.state.event, idea, this.state.ideas)
        )
      },
      () => this.updateFocusedContent(idea)
    );
  };

  onRealtimeDeleteOpenEndedComment = comment => {
    // noinspection JSUnresolvedVariable
    this.setState(
      {
        ideas: RealtimeUi.onNestedContentDeleted(
          this.state.event,
          comment,
          this.state.ideas,
          comment.parent_idea_id
        )
      },
      () => this.updateFocusedContent(null)
    );
  };

  onRealtimeDelete = data => {
    if (this.isEvent(data)) {
      this.onRealtimeEventUpdate(data, true);
    } else {
      if (this.isIdea(data)) {
        if (
          EventQuestionType.isOpenEndedType(
            Event.getQuestionType(this.state.event)
          )
        ) {
          this.onRealtimeDeleteOpenEndedIdea(data);
        }
      } else if (this.isComment(data)) {
        if (
          EventQuestionType.isOpenEndedType(
            Event.getQuestionType(this.state.event)
          )
        ) {
          this.onRealtimeDeleteOpenEndedComment(data);
        }
      }
    }
  };

  onRealtimeStubbed = data => {
    // Treat stubbed events in Presentation mode as deletes
    this.onRealtimeDelete(data);
  };

  isEventStats = stats => {
    return stats.summary !== null && stats.summary !== undefined;
  };

  onRealtimeStatsUpdateOpenEndedIdea = idea => {
    this.onRealtimeStatsUpdatedNewest(idea);

    // Sort ideas when stats update so the cards can reshuffle
    this.setState(
      {
        ideas: this.sortIdeas(
          RealtimeUi.onContentStatsUpdated(
            this.state.event,
            idea,
            this.state.ideas
          )
        )
      },
      () => this.updateFocusedContent(null)
    );
  };

  onRealtimeStatsUpdateOpenEndedComment = comment => {
    // noinspection JSUnresolvedVariable
    this.setState(
      {
        ideas: RealtimeUi.onNestedContentStatsUpdated(
          this.state.event,
          comment,
          this.state.ideas,
          comment.parent_idea_id
        )
      },
      () => this.updateFocusedContent(null)
    );
  };

  onRealtimeStatsUpdateMetrics = stats => {
    this.setState({ stats: stats }, () => {
      // TODO poof the number
      // Animations.animate('.special-chart-label', {
      //   color: '#F00',
      //   height: '200%',
      //   width: '200%'
      // }, () => {
      //   Animations.animate('.special-chart-label', {
      //     color: '#000',
      //     height: '100%',
      //     width: '100%'
      //   });
      // });
    });
  };

  onRealtimeStatsUpdateOpenEndedEventStats = stats => {
    this.onRealtimeStatsUpdateMetrics(stats);
  };

  onRealtimeStatsUpdateQuestionTypeEventStats = stats => {
    const newIdeas = stats.summary.ideas || [];
    const copyOfIdeas = _.cloneDeep(this.state.ideas);
    for (let newIdea of newIdeas) {
      for (let idea of copyOfIdeas) {
        if (idea.id === newIdea.id) {
          idea.choice_count = newIdea.choice_count;
          idea.choice_pct = newIdea.choice_pct;
          idea.choice_freq = newIdea.choice_freq;
          break;
        }
      }
    }

    this.setState({ ideas: copyOfIdeas }, () => {
      this.onRealtimeStatsUpdateMetrics(stats);
    });
  };

  // This must happen before the list update or the logic will never fire.
  onRealtimeStatsUpdateIcons = stats => {
    RealtimeUi.onVoteOccurredOnUserContent(
      stats,
      this.state.ideas,
      false,
      liked => {
        if (liked.id) {
          const newestId = `newest-like-icon-${liked.id}`;
          const presentationId = `presentation-like-icon-${liked.id}`;
          const commentId = `comment-like-icon-${liked.id}`;

          const newestButtonId = LikeButton.getButtonId(newestId);
          const newestIconId = LikeButton.getIconId(newestId);
          const newestShockwave = document.getElementById(newestButtonId);

          if (
            !!document.getElementById(newestButtonId) &&
            !!document.getElementById(newestIconId)
          ) {
            Logger.info("Updating like icon for", newestButtonId, newestIconId);
            LikeEvent.animateLikesForId(newestButtonId, newestIconId);
            if (!!newestShockwave.classList) {
              newestShockwave.classList.add("hover-glow");
            }
            setTimeout(function() {
              if (!!newestShockwave.classList) {
                newestShockwave.classList.remove("hover-glow");
              }
            }, 1000);
          }

          const presentationButtonId = LikeButton.getButtonId(presentationId);
          const presentationIconId = LikeButton.getIconId(presentationId);
          const presentationShockwave = document.getElementById(
            presentationButtonId
          );
          if (
            !!document.getElementById(presentationButtonId) &&
            !!document.getElementById(presentationIconId)
          ) {
            Logger.info(
              "Updating like icon for",
              presentationId,
              presentationIconId
            );
            LikeEvent.animateLikesForId(
              presentationButtonId,
              presentationIconId
            );
            if (!!presentationShockwave.classList) {
              presentationShockwave.classList.add("hover-glow");
            }
            setTimeout(function() {
              if (!!presentationShockwave.classList) {
                presentationShockwave.classList.remove("hover-glow");
              }
            }, 1000);
          }

          const commentButtonId = LikeButton.getButtonId(commentId);
          const commentIconId = LikeButton.getIconId(commentId);
          const commentShockwave = document.getElementById(commentButtonId);
          if (
            !!document.getElementById(commentButtonId) &&
            !!document.getElementById(commentIconId)
          ) {
            Logger.info(
              "Updating like icon for",
              commentButtonId,
              commentIconId
            );
            LikeEvent.animateLikesForId(commentButtonId, commentIconId);
            if (!!commentShockwave.classList) {
              commentShockwave.classList.add("hover-glow");
            }
            setTimeout(function() {
              if (!!commentShockwave.classList) {
                commentShockwave.classList.remove("hover-glow");
              }
            }, 1000);
          }
        }
      },
      disliked => {
        if (disliked.id) {
          const newestId = `newest-dislike-icon-${disliked.id}`;
          const presentationId = `presentation-dislike-icon-${disliked.id}`;
          const commentId = `comment-dislike-icon-${disliked.id}`;

          const newestButtonId = DislikeButton.getButtonId(newestId);
          const newestIconId = DislikeButton.getIconId(newestId);
          const newestShockwave = document.getElementById(newestButtonId);
          if (
            !!document.getElementById(newestButtonId) &&
            !!document.getElementById(newestIconId)
          ) {
            Logger.info(
              "Updating dislike icon for",
              newestButtonId,
              newestIconId
            );
            DislikeEvent.animateDislikesForId(newestButtonId, newestIconId);
            if (!!newestShockwave.classList) {
              newestShockwave.classList.add("hover-glow");
            }
            setTimeout(function() {
              if (!!newestShockwave.classList) {
                newestShockwave.classList.remove("hover-glow");
              }
            }, 1000);
          }

          const presentationButtonId = DislikeButton.getButtonId(
            presentationId
          );
          const presentationIconId = DislikeButton.getIconId(presentationId);
          const presentationShockwave = document.getElementById(
            presentationButtonId
          );
          if (
            !!document.getElementById(presentationButtonId) &&
            !!document.getElementById(presentationIconId)
          ) {
            Logger.info(
              "Updating dislike icon for",
              presentationId,
              presentationIconId
            );
            DislikeEvent.animateDislikesForId(
              presentationButtonId,
              presentationIconId
            );
            if (!!presentationShockwave.classList) {
              presentationShockwave.classList.add("hover-glow");
            }
            setTimeout(function() {
              if (!!presentationShockwave.classList) {
                presentationShockwave.classList.remove("hover-glow");
              }
            }, 1000);
          }

          const commentButtonId = DislikeButton.getButtonId(commentId);
          const commentIconId = DislikeButton.getIconId(commentId);
          const commentShockwave = document.getElementById(commentButtonId);
          if (
            !!document.getElementById(commentButtonId) &&
            !!document.getElementById(commentIconId)
          ) {
            Logger.info(
              "Updating dislike icon for",
              commentButtonId,
              commentIconId
            );
            DislikeEvent.animateDislikesForId(commentButtonId, commentIconId);
            if (!!commentShockwave.classList) {
              commentShockwave.classList.add("hover-glow");
            }
            setTimeout(function() {
              if (!!commentShockwave.classList) {
                commentShockwave.classList.remove("hover-glow");
              }
            }, 1000);
          }
        }
      },
      commented => {
        if (commented.id) {
          const newestId = `newest-comment-icon-${commented.id}`;
          const presentationId = `presentation-comment-icon-${commented.id}`;
          const commentId = `comment-comment-icon-${commented.id}`;

          const newestButtonId = CommentButton.getButtonId(newestId);
          const newestIconId = CommentButton.getIconId(newestId);
          const newestShockwave = document.getElementById(newestButtonId);
          if (
            !!document.getElementById(newestButtonId) &&
            !!document.getElementById(newestIconId)
          ) {
            Logger.info(
              "Updating comment icon for",
              newestButtonId,
              newestIconId
            );
            CommentEvent.animateCommentsForId(newestButtonId, newestIconId);
            if (!!newestShockwave.classList) {
              newestShockwave.classList.add("hover-glow");
            }
            setTimeout(function() {
              if (!!newestShockwave.classList) {
                newestShockwave.classList.remove("hover-glow");
              }
            }, 1000);
          }

          const presentationButtonId = CommentButton.getButtonId(
            presentationId
          );
          const presentationIconId = CommentButton.getIconId(presentationId);
          const presentationShockwave = document.getElementById(
            presentationButtonId
          );
          if (
            !!document.getElementById(presentationButtonId) &&
            !!document.getElementById(presentationIconId)
          ) {
            Logger.info(
              "Updating comment icon for",
              presentationId,
              presentationIconId
            );
            CommentEvent.animateCommentsForId(
              presentationButtonId,
              presentationIconId
            );
            if (!!presentationShockwave.classList) {
              presentationShockwave.classList.add("hover-glow");
            }
            setTimeout(function() {
              if (!!presentationShockwave.classList) {
                presentationShockwave.classList.remove("hover-glow");
              }
            }, 1000);
          }

          const commentButtonId = CommentButton.getButtonId(commentId);
          const commentIconId = CommentButton.getIconId(commentId);
          const commentShockwave = document.getElementById(commentButtonId);
          if (
            !!document.getElementById(commentButtonId) &&
            !!document.getElementById(commentIconId)
          ) {
            Logger.info(
              "Updating comment icon for",
              commentButtonId,
              commentIconId
            );
            CommentEvent.animateCommentsForId(commentButtonId, commentIconId);
            if (!!commentShockwave.classList) {
              commentShockwave.classList.add("hover-glow");
            }
            setTimeout(function() {
              if (!!commentShockwave.classList) {
                commentShockwave.classList.remove("hover-glow");
              }
            }, 1000);
          }
        }
      }
    );
  };

  onRealtimeStatsUpdated = data => {
    if (this.isIdea(data)) {
      if (
        EventQuestionType.isOpenEndedType(
          Event.getQuestionType(this.state.event)
        )
      ) {
        this.onRealtimeStatsUpdateIcons(data);
        this.onRealtimeStatsUpdateOpenEndedIdea(data);
      }
    } else if (this.isComment(data)) {
      this.onRealtimeStatsUpdateIcons(data);
      if (
        EventQuestionType.isOpenEndedType(
          Event.getQuestionType(this.state.event)
        )
      ) {
        this.onRealtimeStatsUpdateOpenEndedComment(data);
      }
    } else if (this.isEventStats(data)) {
      if (
        EventQuestionType.isOpenEndedType(
          Event.getQuestionType(this.state.event)
        )
      ) {
        this.onRealtimeStatsUpdateOpenEndedEventStats(data);
      } else {
        this.onRealtimeStatsUpdateQuestionTypeEventStats(data);
      }
    }
  };

  onRealtimeRemoveNewest = idea => {
    if (!!this.state.newestContent) {
      if (this.state.newestContent.id === idea.id) {
        this.setState({ newestContent: null });
      }
    }
  };

  onRealtimeEditNewest = idea => {
    if (!!this.state.newestContent) {
      if (this.state.newestContent.id === idea.id) {
        this.setState({ newestContent: idea });
      }
    }
  };

  onRealtimeStatsUpdatedNewest = idea => {
    if (!!this.state.newestContent) {
      if (this.state.newestContent.id === idea.id) {
        // NOTE: See RealtimeUI.js onContentStatsUpdated
        const updated = this.state.newestContent;
        updated.like_count = idea.like_count;
        updated.dislike_count = idea.dislike_count;
        updated.comment_count = idea.comment_count;
        updated.hero_replied = idea.hero_replied;
        this.setState({ newestContent: updated });
      }
    }
  };

  openRealtimeConnection = () => {
    // Clear any old realtime connections if they exist (no-op safely if they do not)
    this.unbindAll();

    if (this.state.event && !Event.isClosed(this.state.event)) {
      this.unbinderCreate = Realtime.subscribeToRealtime(
        this.state.event,
        "created",
        data => {
          this.realtimeQueue
            .queue(() => Promise.resolve())
            .then(() => {
              this.onRealtimeCreate(data);
            })
            .catch(this.realtimeErrorCallback);
        },
        this.realtimeErrorCallback
      );

      this.unbinderEdited = Realtime.subscribeToRealtime(
        this.state.event,
        "edited",
        data => {
          this.realtimeQueue
            .queue(() => Promise.resolve())
            .then(() => {
              this.onRealtimeEdit(data);
            })
            .catch(this.realtimeErrorCallback);
        },
        this.realtimeErrorCallback
      );

      this.unbinderDeleted = Realtime.subscribeToRealtime(
        this.state.event,
        "deleted",
        data => {
          this.realtimeQueue
            .queue(() => Promise.resolve())
            .then(() => {
              this.onRealtimeDelete(data);
            })
            .catch(this.realtimeErrorCallback);
        },
        this.realtimeErrorCallback
      );

      this.unbinderStubbed = Realtime.subscribeToRealtime(
        this.state.event,
        "stubbed",
        data => {
          this.realtimeQueue
            .queue(() => Promise.resolve())
            .then(() => {
              this.onRealtimeStubbed(data);
            })
            .catch(this.realtimeErrorCallback);
        },
        this.realtimeErrorCallback
      );

      this.unbinderStatsUpdated = Realtime.subscribeToRealtime(
        this.state.event,
        "stats_updated",
        data => {
          this.realtimeQueue
            .queue(() => Promise.resolve())
            .then(() => {
              this.onRealtimeStatsUpdated(data);
            })
            .catch(this.realtimeErrorCallback);
        },
        this.realtimeErrorCallback
      );
    }
  };

  /**
   * Generic error callback when the page fails to initialize for any reason
   * @param error
   */
  pageLoadErrorCallback = error => {
    Logger.error("Page load error", error);

    // If LIVE is not enabled, we get a 400 error. In that case, show a custom dialog
    if (error.code === 400) {
      this.showDataLoadErrorDialog(error, () => {
        // Redirect them back to dashboard
        NavigationUtils.backToPopin();
      });
    } else {
      this.showLoginErrorDialog(error);
    }
  };

  showLoginErrorDialog = error => {
    const { showDialog } = this.props;
    const { user } = this.state;
    const onHereClicked = () => {
      const { event, match } = this.props;
      const eventSlug = event ? Event.getSlug(event) : match.params.event;

      // Route to signin with slug
      NavigationUtils.routeToLegacy(`signin?path=r/q/${eventSlug}/present`);
    };

    showDialog({
      closeOnEscape: false,
      closeOnClickOutside: false,
      title:
        error.code === 404
          ? "POPin not found"
          : user
          ? "Please Log In"
          : "Not Logged In",
      body: (
        <div>
          {error.code === 404 ? (
            <React.Fragment>
              Sorry, this POPin is unavailable or not found. Click{" "}
              <span
                className="clickable link"
                onClick={NavigationUtils.backToPopin}
              >
                here
              </span>{" "}
              to go back to POPin.
            </React.Fragment>
          ) : (
            <React.Fragment>
              {user ? (
                <React.Fragment>
                  Unverified users are not allowed to view this POPin. Click{" "}
                  <span className="clickable link" onClick={onHereClicked}>
                    here
                  </span>{" "}
                  to log in.
                </React.Fragment>
              ) : (
                <React.Fragment>
                  You must be logged in to view this POPin. Click{" "}
                  <span className="clickable link" onClick={onHereClicked}>
                    here
                  </span>{" "}
                  to log in.
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </div>
      ),
      ok: "Ok",
      onOk: () => {
        if (error.code === 404) {
          NavigationUtils.backToPopin();
        } else {
          onHereClicked();
        }
      }
    });
  };

  realtimeErrorCallback = error => {
    Logger.error("Realtime error", error);
    this.showRealtimeErrorDialog(error);
  };

  showRealtimeErrorDialog = error => {
    // TODO: Mixpanel

    // Show same dialog for now, do we want anything unique?
    this.showDataLoadErrorDialog(
      new400Error(
        "Unable to connect to POPin Live",
        "Please refresh the page and try again"
      )
    );
  };

  /**
   * Generic error callback when the endpoint data fails to initialize for any reason
   * @param error
   */
  dataLoadErrorCallback = error => {
    Logger.error("Data load error", error);
    this.showDataLoadErrorDialog(error, () => {
      // If they are not allowed, or the event is not found, take them back to dashboard
      if (error.code === 403 || error.code === 405 || error.code === 404) {
        NavigationUtils.backToPopin();
      } else {
        // Else just reload
        window.location.reload();
      }
    });
  };

  showDataLoadErrorDialog = (error, customOk) => {
    if (error.code === 403 || error.code === 405 || error.code === 404) {
      this.showLoginErrorDialog(error);
    } else {
      const { showDialog } = this.props;

      // TODO: Mixpanel

      showDialog({
        closeOnEscape: false,
        closeOnClickOutside: false,
        title: "Woops, something went wrong.",
        body: (
          <div className="col no-gutters">
            <div className="col">{error.errorTitle}</div>
            <div className="col">{error.errorMessage}</div>
          </div>
        ),
        ok: "Ok",
        onOk: () => {
          if (customOk) {
            customOk();
          } else {
            window.location.reload();
          }
        }
      });
    }
  };

  /**
   * Sort a list of idea objects to most popular
   *
   * @param ideas
   * @return {*}
   */
  sortIdeas = (ideas) => {
    const popularSort = (a, b) => {
      if (b.like_count === a.like_count && b.total_rating === a.total_rating) {
        // Fall back to times if equal
        return b.created_time - a.created_time;
      }
      return (b.like_count - a.like_count) + (b.total_rating - a.total_rating);
    };

    const commentSort = (a, b) => {
      if (b.comment_count === a.comment_count) {
        // Fall back to times if equal
        return b.created_time - a.created_time;
      }
      return b.comment_count - a.comment_count;
    };

    const newestSort = e => {
      // noinspection JSUnresolvedVariable
      return e.created_time * -1;
    };

    const { activeSort } = this.state;
    switch (activeSort) {
      case Sorts.NEWEST:
        return _.sortBy([].concat(ideas), newestSort);
      case Sorts.MOST_COMMENTED:
        return [].concat(ideas).sort(commentSort);
      default:
        return [].concat(ideas).sort(popularSort);
    }
  };
}

class FocusedCard extends React.Component {
  componentDidMount() {
    const { focused, updateIdea } = this.props;
    commentApi
      .getComments(Ideas.getId(focused))
      .then(comments => {
        Logger.info("Got comments for focused idea", comments);
        const newIdea = _.cloneDeep(focused);
        newIdea.comments = comments || [];
        updateIdea(newIdea);
      })
      .catch(error => {
        Logger.error("Error loading comments", error);
      });
  }

  render() {
    const { user, event, focused, showFocused, onClick, closeCard } = this.props;
    return (
      <div
        className={`col no-gutters focused-presentation-card flex-grow d-flex flex-column pt-0 px-0 mt-3 ${
          showFocused ? "slide-out" : "slide-in"
        }`}
        onClick={onClick}
      >
        <div className="row no-gutters justify-content-end hide-comments-container">
          <div
            className="hide-comments-button clickable"
            onClick={() => closeCard("collapse-button-clicked")}
          >
            <i className="material-icons">clear</i>
          </div>
        </div>
        <Card
          focused={focused}
          user={user}
          archiveId={`presentation-archive-icon-${Ideas.getId(focused)}`}
          likeIconId={`presentation-like-icon-${Ideas.getId(focused)}`}
          dislikeIconId={`presentation-dislike-icon-${Ideas.getId(focused)}`}
          commentIconId={`presentation-comment-icon-${Ideas.getId(focused)}`}
          event={event}
          idea={focused}
          canExpand={false}
          className="w-100 fix-me-daddy border-bottom pt-3 px-3 h-40"
        />
        <div className="col no-gutters children-cards h-60 overflow-auto">
          {!!focused.comments &&
          focused.comments.length > 0 &&
          focused.comments.filter(c => !c.deleted).length > 0 ? (
            focused.comments
              .filter(c => !c.deleted)
              .map(comment => {
                return (
                  <CommentCard
                    key={comment.id}
                    comment={comment}
                    closeCard={closeCard}
                  />
                );
              })
          ) : (
            <div className="row no-gutters h-100">
              <div className="m-auto font-weight-semibold font-size-xxl font-color-med">
                No comments to show
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

class CommentCard extends React.Component {
  render() {
    const { comment } = this.props;
    return (
      <div className="no-gutters p-0 m-2 comment-card c-medium">
        <div className="row no-gutters">
          <div className="col no-gutters mt-2">
            <AuthorSection response={comment} child={false} />
            <div className="comment-description">{comment.description}</div>
          </div>
          <div className="col-3 no-gutters text-right d-flex align-items-center justify-content-end pt-4">
            <div className="row no-gutters">
              <div className="col" />

              {/* Like Button */}
              <div className="like-button-container comment-vote-button-container">
                <LikeButton
                  id={`comment-like-icon-${comment.id}`}
                  className="my-auto"
                />
              </div>
              <div className="ml-1 mr-3 text-left my-auto no-gutters text-container">
                {Ideas.getLikeCount(comment)}
              </div>

              {/* Dislike Button */}
              <div className="dislike-button-container comment-vote-button-container">
                <DislikeButton
                  id={`comment-dislike-icon-${comment.id}`}
                  className="my-auto"
                />
              </div>
              <div className="ml-1 mr-3 text-left my-auto no-gutters text-container">
                {Ideas.getDislikeCount(comment)}
              </div>
            </div>

            {/* Archive Button */}
            {!!comment && (
              <ArchiveButton
                id={`presentation-archive-icon-${Comments.getId(comment)}`}
                comment={comment}
                className="my-auto"
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

class Card extends React.Component {
  clicked = () => {
    const { onClick } = this.props;
    if (onClick) {
      onClick();
    }
  };

  onClickPdf = ($event, pdf) => {
    $event.preventDefault();

    if (!!pdf) {
      const url = Media.getPdfUrl(pdf);
      if (!!url) {
        NavigationUtils.openTab(url);
      }
    }
  };

  render() {
    const {
      event,
      user,
      idea,
      archiveId,
      likeIconId,
      dislikeIconId,
      commentIconId,
      id,
      className,
      comment,
      canExpand,
      focused
    } = this.props;
    let photo = null;
    let pdf = null;
    if (!!idea) {
      photo = Response.getPhotoAttachment(idea);
      pdf = Response.getPdfAttachment(idea);
    }
    if (!!comment) {
      photo = Response.getPhotoAttachment(comment);
      pdf = Response.getPdfAttachment(comment);
    }
    const originalPhotoUrl = !!photo ? Media.getPhotoUrl(photo) : "";
    const photoUrl = !!photo ? Media.getPhotoUrl(photo, null, 300) : "";

    // If we have a photo - don't show the card because we are afraid of pictures of penis.
    // Ask cindy
    if (!!photo) {
      return null;
    }

    const votingMode = !!event ? Event.getVotingMode(event) : null;

    return (
      <div
        id={id ? id : ""}
        className={`d-flex flex-column no-gutters ${
          className ? className : ""
        } c-medium`}
        onClick={this.clicked}
      >
        <div className="row no-gutters">
          <div className="col no-gutters mt-2">
            <AuthorSection
              response={!!idea ? idea : !!comment ? comment : null}
              child={false}
            />
          </div>

          <div className="col no-gutters" />

          <div className="col no-gutters text-right">
            {!!idea && (
              <div className="row no-gutters">
                <div className="col" />
              { votingMode === 'star-rating' ?
              <>
                <RatingButton
                  id={likeIconId ? likeIconId : ""}
                  className="my-auto"
                  rating={Ideas.getAvgRating(idea)}
                />
                <div
                  className="ml-2 mr-3 text-left my-auto no-gutters text-container"
                  onClick={PresentationPageAnalytics.failedUpvoteAttempt}
                >
                  {Ideas.getAvgRating(idea).toFixed(1)}
                </div>
              </>
              :
              <>
                {/* Like Button */}
                <div
                  className="like-button-container button-container"
                  onClick={PresentationPageAnalytics.failedUpvoteAttempt}
                >
                  <LikeButton
                    id={likeIconId ? likeIconId : ""}
                    className="my-auto"
                  />
                </div>
                <div
                  className="ml-1 mr-3 text-left my-auto no-gutters text-container"
                  onClick={PresentationPageAnalytics.failedUpvoteAttempt}
                >
                  {Ideas.getLikeCount(idea)}
                </div>

                {/* Dislike Button */}
                <div
                  className="dislike-button-container button-container"
                  onClick={PresentationPageAnalytics.failedDownvoteAttempt}
                >
                  <DislikeButton
                    id={dislikeIconId ? dislikeIconId : ""}
                    className="my-auto"
                  />
                </div>
                <div
                  className="ml-1 mr-3 text-left my-auto no-gutters text-container"
                  onClick={PresentationPageAnalytics.failedDownvoteAttempt}
                >
                  {Ideas.getDislikeCount(idea)}
                </div>
              </>
              }

                {/* Comment Button */}
                <div
                  className="comment-button-container button-container"
                  onClick={PresentationPageAnalytics.failedCommentAttempt}
                >
                  <CommentButton
                    id={commentIconId ? commentIconId : ""}
                    className="my-auto"
                  />
                </div>
                <div
                  className="ml-1 mr-3 text-left my-auto no-gutters text-container"
                  onClick={PresentationPageAnalytics.failedCommentAttempt}
                >
                  {Ideas.getCommentCount(idea)}
                </div>
              </div>
            )}

            {!!comment && (
              <div className="row no-gutters">
                <div className="col" />

                {/* Like Button */}
                <div className="like-button-container button-container">
                  <LikeButton
                    id={likeIconId ? likeIconId : ""}
                    className="my-auto"
                  />
                </div>
                <div className="col text-left my-auto no-gutters text-container">
                  {Ideas.getLikeCount(comment)}
                </div>

                {/* Dislike Button */}
                <div className="dislike-button-container button-container">
                  <DislikeButton
                    id={dislikeIconId ? dislikeIconId : ""}
                    className="my-auto"
                  />
                </div>
                <div className="col text-left my-auto no-gutters text-container">
                  {Ideas.getDislikeCount(comment)}
                </div>
              </div>
            )}
          </div>
        </div>

        {!!pdf && (
          <div
            className="row no-gutters d-inline-block clickable"
            onClick={$e => this.onClickPdf($e, pdf)}
          >
            <i className="material-icons mr-3">attachment</i>1 Attachment
          </div>
        )}

        {!!idea && (
          <div className={`flex-fill card-contents content-text text-wrap ${focused ? "overflow-auto" : "overflow-hidden"}`}>
            <span id={id ? `content-${id}` : ""}>{Ideas.getContent(idea)}</span>
          {/* 
            // This was overkill - but keeping around just in case
            { focused ?
            <span id={id ? `content-${id}` : ""}>{Ideas.getContent(idea)}</span>
            :
            <TruncateMarkup lines={3}>
              <span id={id ? `content-${id}` : ""}>{Ideas.getContent(idea)}</span>
            </TruncateMarkup>
          } */}
          </div>
        )}

        {!!comment && (
          <TextTruncate
            id={id ? `content-${id}` : ""}
            containerClassName={`flex-fill card-contents content-text text-wrap ${
              focused ? "overflow-auto" : "overflow-hidden"
            }`}
            line={focused ? 0 : 3}
            text={Ideas.getDescription(comment)}
          />
        )}

        {!!photo && (
          // If the card has a photo, allocate space for it - so that when it loads the page won't flicker
          <div style={{ minHeight: 300 }} className="row no-gutters">
            <img
              src={photoUrl}
              alt="Post Media Content"
              onClick={() => NavigationUtils.openTab(originalPhotoUrl)}
            />
          </div>
        )}

        <div className="row no-gutters expand-footer">
          <div className="col" />

          <div className={`row ${canExpand ? "m-1" : "my-1"} bg-white`}>
            {/* Archive Button */}
            {!!idea && (
              <ArchiveButton
                id={archiveId ? archiveId : ""}
                user={user}
                idea={idea}
                className="my-auto pr-2"
              />
            )}

            {/* Expand footer */}
            {canExpand && (
              <div className="row no-gutters expand-button rounded">
                <span>Expand</span>
                <i className="ml-1 material-icons">expand_more</i>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const AuthorSection = ({ response, child }) => {
  return (
    <div className="row no-gutters author-info">
      <div
        className={`${!!child ? "child-card" : "toplevel-card"} ${
          Response.isHeroCreated(response) ? "is-creator" : "is-not-creator"
        }`}
      >
        {Response.getAuthorName(response)}
      </div>
    </div>
  );
};

class CodeSection extends React.Component {
  render() {
    const {
      event,
      collection,
      stats,
      countdownShown,
      canSwitchToPreviousEvent,
      canSwitchToNextEvent,
      switchToNextEvent,
      switchToPreviousEvent
    } = this.props;
    const eventCount = !!collection
      ? Collection.getEvents(collection).length
      : 0;
    return (
      <div
        className="text-center col d-flex flex-column pl-3 pr-3"
        style={{ backgroundColor: this.getBackgroundColor() }}
      >
        {/* Top (Needs set width or image will not evaluate a size) */}

        {this.renderLogoSection(event)}

        {eventCount > 1 && (
          <div className="row nav-arrows-container d-flex my-5 mx-auto p-2 border rounded border-white font-size-lg justify-content-center align-items-center">
            <i
              className={`material-icons nav-arrow clickable ${
                canSwitchToPreviousEvent ? "" : "invisible"
              }`}
              onClick={switchToPreviousEvent}
            >
              keyboard_arrow_left
            </i>

            {`Question ${this.getIndexForEventInCollection(event, collection) +
              1} of ${eventCount}`}

            <i
              className={`material-icons nav-arrow clickable ${
                canSwitchToNextEvent ? "" : "invisible"
              }`}
              onClick={switchToNextEvent}
            >
              keyboard_arrow_right
            </i>
          </div>
        )}

        <div className="row d-flex" style={{ color: this.getTextColor() }}>
          {this.renderTopSection(event, countdownShown)}
        </div>

        <div
          className="row d-flex centered-code-section mt-auto mb-5"
          style={{ color: this.getTextColor() }}
        >
          {this.renderMiddleSection(event, collection)}
        </div>

        {/* Bottom */}
        <div
          className="row d-flex mb-auto"
          style={{ color: this.getTextColor() }}
        >
          {this.renderBottomSection(stats)}
        </div>
      </div>
    );
  }

  getIndexForEventInCollection = (event, collection) => {
    const events = Collection.getEvents(collection);
    let index = -1;
    for (let i = 0; i < events.length; ++i) {
      const e = events[i];
      if (Event.getId(event) === Event.getId(e)) {
        index = i;
        break;
      }
    }
    return index;
  };

  getTextColor = () => {
    const { event } = this.props;
    // use custom text color if set
    const customColor = _.get(event, "theme.text_color");
    if (customColor) {
      return customColor;
    } else {
      return null;
    }
  };

  getBackgroundColor = () => {
    const { event, collection } = this.props;

    // Something is wrong, just be white
    if (!event && !collection) {
      return this.getBackgroundColorForIndex(0);
    } else {
      // use custom bg color if set
      const customColor = _.get(event, "theme.bg_color");
      if (customColor) {
        return customColor;
      }

      const events = Collection.getEvents(collection);
      let index = -1;
      for (let i = 0; i < events.length; ++i) {
        const e = events[i];
        if (Event.getId(event) === Event.getId(e)) {
          index = i;
          break;
        }
      }

      return this.getBackgroundColorForIndex(index);
    }
  };

  getBackgroundColorForIndex = index => {
    const colors = ["#36A4DB", "#2364AA", "#73BFB8", "#EA7317"];

    // Something is wrong, just be white
    Logger.info("Index: ", index);
    if (index < 0) {
      return "#FFFFFF";
    } else {
      const picked = index % colors.length;
      Logger.info("Picked: ", picked);
      return colors[picked];
    }
  };

  getLogoDimension = media => {
    const MAX_WIDTH = 300;
    const MAX_HEIGHT = 200;
    if (media.photo_width <= MAX_WIDTH && media.photo_height <= MAX_HEIGHT) {
      return { width: media.photo_width, height: media.photo_height };
    } else if (media.photo_aspect_ratio >= 1.5) {
      return { width: Math.ceil(MAX_WIDTH, media.photo_width) };
    } else {
      return { height: Math.ceil(MAX_HEIGHT, media.photo_height) };
    }
  };

  renderLogoSection = event => {
    var customLogo = _.get(event, "theme.logo_media");
    if (customLogo) {
      const dimension = this.getLogoDimension(customLogo);
      console.log("Dimension", dimension);
      return (
        <div
          className="mx-auto mt-4"
          style={dimension}
          onClick={PresentationPageAnalytics.failedPopinLogoClick}
        >
          {dimension.width && dimension.height && (
            <img
              src={customLogo.photo}
              alt="Custom Logo"
              width={dimension.width}
              height={dimension.height}
            />
          )}
          {dimension.width && (
            <img
              src={customLogo.photo}
              alt="Custom Logo"
              width={dimension.width}
            />
          )}
          {dimension.height && (
            <img
              src={customLogo.photo}
              alt="Custom Logo"
              height={dimension.height}
            />
          )}
        </div>
      );
    } else {
      return (
        <div
          className="mx-auto brand-logo mt-4"
          onClick={PresentationPageAnalytics.failedPopinLogoClick}
        >
          <img src={POPinLogo} alt="POPin Logo" />
        </div>
      );
    }
  };

  renderTopSection = (event, countdownShown) => {
    const getEndDate = event => {
      const endTime = Event.getEndTime(event);
      return DateTime.format(endTime, "MMM DD, YYYY");
    };

    if (Event.isClosed(event)) {
      return (
        <div className="mx-auto font-weight-bold font-size-xxl mt-5 pt-5 pl-4 pr-4">
          <div>This POPin ended on </div>
          <div>{getEndDate(event)}</div>
        </div>
      );
    } else {
      return (
        <div className="flex-fill">
          {!!countdownShown && (
            <CountdownContainer
              id="countdown-container-presentation"
              event={event}
            />
          )}
        </div>
      );
    }
  };

  renderMiddleSection = (event, collection) => {
    const getDisplayedCode = (event, collection) => {
      let code;

      if (!!collection) {
        code = Collection.getShortCode(collection);
      }
      if (!code) {
        code = Event.getShareLink(event);
      }

      return code;
    };

    const hasShortCode = collection => {
      return !!collection && !!Collection.getShortCode(collection);
    };

    const host = window.location.hostname;
    const isDemo = _.includes(host, "demo.");
    const url = isDemo ? `popinnow.com/demo` : `popin.live`;

    return (
      <div className="m-auto col">
        <div className="col no-gutters p-0 code-block">
          {hasShortCode(collection) ? (
            <div className="display-4 w-100">
              <div className="code-prompt fix-text">Join at</div>
              <div className="code-prompt font-weight-bold kerning-1 fix-text">
                <span
                  onClick={() =>
                    PresentationPageAnalytics.failedMarketingSiteAttempt()
                  }
                  className="dont-change-me-bruh"
                >
                  {url}
                </span>
              </div>
              <div className="code-prompt fix-text">and enter code</div>
              <div className="code-prompt font-weight-bold code-display kerning-2">
                {getDisplayedCode(event, collection)}
              </div>
            </div>
          ) : (
            <div className="display-4 w-100">
              <div className="code-prompt fix-text">Navigate to</div>
              <div className="code-prompt font-weight-bold kerning-1 fix-text">
                {getDisplayedCode(event, collection)}
              </div>
              <div className="code-prompt fix-text">to join</div>
            </div>
          )}
        </div>
      </div>
    );
  };

  renderBottomSection = stats => {
    return (
      <div className="mx-auto mb-auto col">
        <div className="col no-gutters p-0 code-block presentation-stats">
          <div className="row no-gutters justify-content-center">
            <div className="col" />

            {/* Contributor Count */}
            <div className="presentation-stats row no-gutters justify-content-center">
              <i className="presentation-stats-icons total-contributors material-icons">
                group
              </i>
              <div className="presentation-stats-text ml-4">
                {EventStats.getUsersWhoContributedCount(stats)}
              </div>
            </div>

            <div className="col" />
          </div>
        </div>
      </div>
    );
  };
}

class ListSection extends React.Component {
  onCardClicked = idea => {
    const { onFocused, updateShowFocused } = this.props;
    updateShowFocused(() => {
      setTimeout(function() {
        onFocused(idea);
      }, 500);
    });
  };

  scrollToNewestContent = () => {
    const { newestContent } = this.props;
    if (!!newestContent) {
      // Scroll to the element if it is visible
      const element = $(`#presentation-${newestContent.id}`);
      const offset = element.offset();

      // Offset is not defined if the DOM has not been rendered
      if (offset) {
        $(".list-section").animate(
          {
            scrollTop: offset.top
          },
          null,
          null,
          () => {
            // Add Pulse/Highlight Animation
            element.addClass("card-pulse");
            element.addClass("card-glow");

            // Remove Pulse/Highlight Animation
            // - animation can be added again
            setTimeout(function() {
              element.removeClass("card-pulse");
              element.removeClass("card-glow");
            }, 1500);
          }
        );
      }
    }
  };

  renderEventHeader = (event, ideas) => {
    return (
      <div className="row no-gutters w-100 event-header align-self-start">
        <div
          className={`col no-gutters display-4 event-name ${
            !ideas || ideas.length === 0 ? "my-auto" : ""
          }`}
        >
          {Event.getName(event)}
        </div>
      </div>
    );
  };

  handleSortDropdownClick() {
    PresentationPageAnalytics.sortDropdownClicked();
  }

  renderOpenEndedSortDropdown = (
    event,
    ideas,
    focused,
    activeSort,
    onSortPicked
  ) => {
    if (
      ideas &&
      ideas.length > 1 &&
      EventQuestionType.isOpenEndedType(Event.getQuestionType(event)) &&
      !focused
    ) {
      return (
        <div className="container-fluid">
          <div className="row sort-dropdown-container w-100 d-flex justify-content-end p-2">
            <span className="dropdown-label filter-label-text">Sort by</span>
            <div
              className="sort-dropdown dropdown-toggle"
              id="sortDropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <div className="row no-gutters">
                <span
                  className="col-md-auto dropdown-button clickable align-items-between"
                  onClick={() => this.handleSortDropdownClick()}
                >
                  <div className="row no-gutters justify-content-between rounded shadow-sm bg-white p-1">
                    <span className="col filter-label-text">{activeSort}</span>
                    <i className="col-sm-2 material-icons filter-label-icon">
                      expand_more
                    </i>
                  </div>
                </span>
              </div>
            </div>

            <div className="dropdown-menu" aria-labelledby="sortDropdown">
              <div
                className={`clickable dropdown-menu-item ${
                  activeSort === Sorts.MOST_POPULAR ? "active-sort" : ""
                }`}
                onClick={$e => onSortPicked($e, Sorts.MOST_POPULAR)}
              >
                {Sorts.MOST_POPULAR}
              </div>
              <div
                className={`clickable dropdown-menu-item ${
                  activeSort === Sorts.NEWEST ? "active-sort" : ""
                }`}
                onClick={$e => onSortPicked($e, Sorts.NEWEST)}
              >
                {Sorts.NEWEST}
              </div>
              <div
                className={`clickable dropdown-menu-item ${
                  activeSort === Sorts.MOST_COMMENTED ? "active-sort" : ""
                }`}
                onClick={$e => onSortPicked($e, Sorts.MOST_COMMENTED)}
              >
                {Sorts.MOST_COMMENTED}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  renderPageContents = (
    user,
    event,
    ideas,
    stats,
    focused,
    showFocused,
    onCommentsFetched
  ) => {
    if (!!focused) {
      return (
        <div className="col focused-section d-flex">
          <FocusedCard
            user={user}
            event={event}
            showFocused={showFocused}
            focused={focused}
            onClick={() => this.onCardClicked(null)}
            closeCard={this.onCardClicked}
            updateIdea={onCommentsFetched}
          />
        </div>
      );
    } else {
      return (
        <div className="event-body-container list-section col flex-grow align-self-stretch pt-4">
          {EventQuestionType.isOpenEndedType(Event.getQuestionType(event)) ? (
            <OpenEndedContent
              user={user}
              event={event}
              ideas={ideas}
              stats={stats}
              onCardClicked={this.onCardClicked}
            />
          ) : (
            <QuestionTypeContent
              user={user}
              event={event}
              ideas={ideas}
              stats={stats}
            />
          )}
        </div>
      );
    }
  };

  renderNewestContent = (user, event, newestContent, focused, activeSort) => {
    return null;
    // if (!!newestContent && !focused && activeSort !== Sorts.NEWEST &&
    //   EventQuestionType.isOpenEndedType(Event.getQuestionType(event))) {
    //   return (
    //     <div className="col mx-0 newest-content-container d-flex px-0 no-gutters animate-newest justify-content-center">
    //       <div className="font-weight-dark font-size-md font-color-light py-3 px-3 newest-content-header">
    //         Newest Response
    //       </div>
    //       <Card
    //         user={ user }
    //         onClick={ () => this.onCardClicked(newestContent) }
    //         likeIconId={ `newest-like-icon-${ Ideas.getId(newestContent) }` }
    //         dislikeIconId={ `newest-dislike-icon-${ Ideas.getId(newestContent) }` }
    //         commentIconId={ `newest-comment-icon-${ Ideas.getId(newestContent) }` }
    //         idea={ newestContent }
    //         canExpand={ true }
    //         id={ `newest-${ Ideas.getId(newestContent) }` }
    //         className="newest-content presentation-card clickable my-0 mx-3" />
    //     </div>
    //   );
    // } else {
    //   return null;
    // }
  };

  render() {
    const {
      user,
      event,
      ideas,
      stats,
      newestContent,
      showFocused,
      focused,
      onCommentsFetched,
      activeSort,
      onSortPicked
    } = this.props;
    return (
      <div className="col h-100-when-large d-flex flex-column mx-0 px-0">
        <div
          className={`event-header-container row no-gutters py-3 ${
            !!focused ? "d-none" : "d-block"
          }`}
        >
          {this.renderEventHeader(event, ideas)}
        </div>

        {this.renderOpenEndedSortDropdown(
          event,
          ideas,
          focused,
          activeSort,
          onSortPicked
        )}

        {this.renderPageContents(
          user,
          event,
          ideas,
          stats,
          focused,
          showFocused,
          onCommentsFetched
        )}

        {this.renderNewestContent(
          user,
          event,
          newestContent,
          focused,
          activeSort
        )}
      </div>
    );
  }
}

// Component for only Open Ended question types
const OpenEndedContent = ({ user, event, ideas, stats, onCardClicked }) => {
  return (
    <div className="col no-gutters h-100 d-flex flex-column">
      {ideas && ideas.length > 0 && ideas.filter(i => !i.deleted).length > 0 ? (
        <FlipMove
          className="mx-auto col"
          duration={1000}
          delay={0}
          easing={"cubic-bezier(0.39, 0, 0.45, 1.4)"}
          staggerDurationBy={22}
          staggerDelayBy={0}
        >
          {ideas
            .filter(i => !i.deleted)
            .map(idea => {
              return (
                <div key={`presentation-${Ideas.getId(idea)}`}>
                  <Card
                    focused={false}
                    className="presentation-card clickable c-medium"
                    id={`presentation-${Ideas.getId(idea)}`}
                    user={user}
                    archiveId={`presentation-archive-icon-${Ideas.getId(idea)}`}
                    likeIconId={`presentation-like-icon-${Ideas.getId(idea)}`}
                    dislikeIconId={`presentation-dislike-icon-${Ideas.getId(
                      idea
                    )}`}
                    commentIconId={`presentation-comment-icon-${Ideas.getId(
                      idea
                    )}`}
                    event={event}
                    idea={idea}
                    canExpand={true}
                    onClick={() => onCardClicked(idea)}
                  />
                </div>
              );
            })}
        </FlipMove>
      ) : (
        <div className="row no-gutters h-100">
          <div className="m-auto font-weight-semibold font-size-xxl font-color-med">
            No responses to show
          </div>
        </div>
      )}
    </div>
  );
};

// Component for Binary, MC, Scale question types
const QuestionTypeContent = ({ event, ideas, stats }) => {
  return (
    <div className="row no-gutters h-100">
      <div className="col no-gutters d-flex flex-grow h-100 w-100">
        <ChartContainer event={event} ideas={ideas} stats={stats} />
      </div>
    </div>
  );
};

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps, {
  showDialog
})(PresentationPage);
